/* eslint-disable */
<template>
  <header>
    <nav>
      <div class="logo">
        <router-link to="/"
          ><img
            src="../assets/png/LOGO.svg"
            alt="logo Wanview"
            width="170"
            height="38"
        /></router-link>
      </div>
      <div class="btns">
        <div class="menu">
          <label for="menu" class="material-icons-outlined"> menu </label>
          <input type="checkbox" name="menu" id="menu" />
        </div>
        <div class="links">
          <a href="/#formulaire" class="more">Demander votre démo</a>
          <a href="https://my.wanview.fr">Me connecter</a>
        </div>
      </div>
    </nav>
  </header>
</template>

<script>
export default {
  mounted() {
    let nav = document.querySelector("nav");
    window.addEventListener("scroll", () => {
      if (window.scrollY > 0) {
        nav.classList.add("fixed");
      } else if (window.scrollY == 0) {
        nav.classList.remove("fixed");
      }
    });
  },
};
</script>

<style lang="scss">
@import "../assets/variables.scss";
@import url("https://fonts.googleapis.com/css2?family=Nunito:ital,wght@0,400;0,500;0,600;0,700;1,400;1,500;1,600&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Work+Sans:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;1,100;1,200;1,300;1,400;1,500;1,600;1,700&display=swap");
header {
  nav {
    display: flex;
    flex-flow: row;
    justify-content: space-around;
    align-items: center;
    background-color: transparent;
    position: fixed;
    width: 100%;
    top: 50px;
    z-index: 99;
    @media screen and (max-width: 700px) {
      top: 30px;
    }
    transition: all 400ms;
    &.fixed {
      top: 0;
      padding: 0.4em 0;
      background: transparent linear-gradient(180deg, #0f3353 0%, #0a2946 100%)
        0% 0% no-repeat padding-box;

      // background: linear-gradient(
      //   0deg,
      //   rgba(238, 174, 202, 0) 0%,
      //   $bg-blue 30%
      // );
    }
    div.btns {
      .menu {
        display: none;
        input {
          display: none;
        }
        @media all and(max-width: 900px) {
          // display: flex;
        }
        label {
          background-color: $secondary;
          color: $light;
          padding: 0.2em 0.5em;
          border: none;
          border-radius: 5px;
          font-size: 24px;
        }
      }
      .links {
        @media all and(max-width: 900px) {
          .more {
            display: none;
          }
          // display: none;
          display: flex;
          flex-flow: column;
        }
        a {
          font: normal normal 600 15px/36px Work Sans;
          @extend %btn;
          &:nth-child(1) {
            background-color: $secondary;
            color: $light;
          }
          &:nth-child(2) {
            color: $primary;
            font-weight: 700;
            transition: background 400ms;
            &:hover {
              background-color: lighten($color: $primary, $amount: 90);
            }
          }
        }
        a + a {
          margin-left: 0.5em;
        }
      }
    }
    div.logo {
      img {
        width: 200px;
        @media all and(max-width: 900px) {
          width: 100px;
        }
        // opacity: 0;
      }
    }
  }
}

.more {
  transition-duration: 0.2s;
}
.more:hover {
  box-shadow: 0px 2px 10px #c7a972c1;
}
</style>
